export function NoteIcon(props: { class?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <g clip-path="url(#clip0_16045_83709)">
        <path
          d="M7 1.5C10.03 1.5 12.5 3.97 12.5 7C12.5 10.03 10.03 12.5 7 12.5C3.97 12.5 1.5 10.03 1.5 7C1.5 3.97 3.97 1.5 7 1.5ZM7 0C3.13 0 0 3.13 0 7C0 10.87 3.13 14 7 14C10.87 14 14 10.87 14 7C14 3.13 10.87 0 7 0Z"
          fill="currentColor"
        />
        <path
          d="M7 7.78004V3.79004"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.00078 9.41003C6.61078 9.41003 6.30078 9.72003 6.30078 10.11C6.30078 10.5 6.61078 10.81 7.00078 10.81C7.39078 10.81 7.70078 10.5 7.70078 10.11C7.70078 9.72003 7.39078 9.41003 7.00078 9.41003Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_16045_83709">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
